/**
 * Lịch sử điểm hạng.
 *
 * Trước đây màn này tự dựng bằng Tailwind rời (ảnh tròn 92px, gạch ngang tự vẽ,
 * nút "Tải thêm" kiểu cũ) nên trông không giống phần còn lại của app. Dựng lại
 * bằng đúng các khối chung: page-head, ui-card, list-row.
 */
import * as _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";

import Navbar from "../../components/navbar";
import TIcon from "../../components/ui/TIcon";
import * as SBService from "../../helpers/sportbookService";
import { loaderState, showBottomBarState, userState } from "../../states/common";

const initials = (name: string) =>
  name.split(" ").filter(Boolean).slice(-2).map((w) => w[0]).join("").toUpperCase();

const RankingHistory = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useRecoilState(loaderState);
  const [user] = useRecoilState(userState);
  const [, setBottomBar] = useRecoilState(showBottomBarState);

  const [page, setPage] = useState(1);
  const [hasNext, setHasNext] = useState(false);
  const [histories, setHistories] = useState<any[]>([]);

  const LIMIT = 20;

  useEffect(() => {
    document.title = "Biadi — Lịch sử điểm hạng";
    setBottomBar(true);

    const load = async () => {
      setLoader(true);
      const rsp = await SBService.getProfileRankingHistory({ page: 1, limit: LIMIT }).catch(
        () => null
      );
      setHistories(Array.isArray(rsp?.data) ? rsp.data : []);
      setHasNext(!!rsp?.hasNextPage);
      setLoader(false);
    };

    if (!_.isEmpty(user.id)) {
      load();
    }
  }, [user.id]);

  const loadMore = async () => {
    if (!hasNext || loader) return;
    const next = page + 1;
    setLoader(true);
    const rsp = await SBService.getProfileRankingHistory({ page: next, limit: LIMIT }).catch(
      () => null
    );
    if (Array.isArray(rsp?.data)) {
      setHistories((all) => all.concat(rsp.data));
      setPage(next);
      setHasNext(!!rsp.hasNextPage);
    }
    setLoader(false);
  };

  return (
    <>
      <Navbar title="Lịch sử điểm hạng" />

      {/* Thẻ tóm tắt: ai, hạng gì, đang bao nhiêu điểm — bối cảnh cho mọi dòng
          bên dưới, nên đứng trước danh sách. */}
      <section className="ui-card profile-card" style={{ marginTop: 8 }}>
        <div className="who">
          <span className="avatar avatar-ring" style={{ width: 56, height: 56, fontSize: 15 }}>
            {user.profilePicture ? (
              <img src={user.profilePicture} alt="" />
            ) : (
              initials(user.name || "?")
            )}
          </span>
          <div className="id">
            <span className="name">{user.name || "—"}</span>
            <div className="tags">
              <span className="tag-solid">HẠNG CƠ {user.ranking?.code ?? "--"}</span>
              <span className="tag-ghost">{user.score?.toString() ?? "0"} ĐIỂM</span>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="section-head">
          <h2>BIẾN ĐỘNG ĐIỂM</h2>
        </div>

        {histories.length > 0 ? (
          <>
            <div className="ui-card list">
              {histories.map((item: any, i: number) => (
                <div key={item.id ?? i} className="list-row rank-log">
                  <div className="what">
                    <span className="title">
                      {item.league ? `Thi đấu giải ${item.league.name}` : item.note || "Điều chỉnh điểm"}
                    </span>
                    <span className="when">
                      {moment(item.createdAt).format("DD/MM/YYYY · HH:mm")}
                    </span>
                  </div>
                  <span className={`delta ${item.point > 0 ? "up" : item.point < 0 ? "down" : "flat"}`}>
                    {item.point > 0 ? `+${item.point}` : item.point}
                  </span>
                </div>
              ))}
            </div>

            {hasNext ? (
              <button
                type="button"
                className="btn btn-outline btn-block"
                style={{ marginTop: 14 }}
                onClick={loadMore}
                disabled={loader}
              >
                {loader ? "ĐANG TẢI…" : "TẢI THÊM"}
              </button>
            ) : null}
          </>
        ) : !loader ? (
          <div className="ui-card empty-state">
            <TIcon name="history" />
            <div className="t">Chưa có biến động điểm nào</div>
            <div className="h">Điểm hạng thay đổi sau mỗi trận được xác nhận</div>
            <button
              type="button"
              className="btn btn-primary"
              style={{ marginTop: 14 }}
              onClick={() => navigate("/league")}
            >
              XEM GIẢI ĐẤU
            </button>
          </div>
        ) : null}
      </section>
    </>
  );
};

export default RankingHistory;
